import api from './api';
import { Project } from '../types/project';

interface ProjectsResponse {
  projects: Project[];
  pagination?: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export const projectService = {
  // Get all projects for a workspace
  getAll: async (workspaceId: string): Promise<ProjectsResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/projects`);
    return response.data;
  },

  // Get project by ID
  getById: async (workspaceId: string, projectId: string): Promise<{ project: Project }> => {
    const response = await api.get(`/workspaces/${workspaceId}/projects/${projectId}`);
    return response.data;
  }
};
